import { Store } from "../../types/contexts/authContext/store.types";

const initialState: Store = {
	member: null
};

export default initialState;
